import LazyLoading from './lib/lazy-loading'
import AnimationScenes from './template-parts/common/animationScenes'
import Menu from './template-parts/common/menu'
import Filters from './template-parts/components/filters'
import Pagination from './template-parts/components/pagination'
import ContactForm from './template-parts/common/contact-form'
import ContactForm2 from './template-parts/common/contact-form2'
import TopFooter from './template-parts/common/top-footer'
import ContactForm2Mobile from './template-parts/common/contact-form2_mobile'
import CFBlogMobile from './template-parts/common/cf_blogmobile'
import CFBlog from './template-parts/common/cf_blog'
import Hero from './template-parts/common/hero'
import Title from './template-parts/common/title'
import Footer from './template-parts/common/footer'
import EnrollmentBanner from './template-parts/sections/enrollment-banner'
import FeaturedAccordion from './template-parts/sections/featured-accordion'
import GeBl11MobileAccordion from './template-parts/sections/grado-bl11-mobile-accordion'
import DistribFaqsMobileAccordion from './template-parts/sections/distrib-faqs-mobile-accordion'
import HomeBl10Accordion from './template-parts/sections/home-bl10-accordion'
import TemarioAccordion from './template-parts/sections/temario-accordion'
import CentrosAccordion from './template-parts/sections/centros-accordion'
import FeaturedVideo from './template-parts/sections/featured-video'
import FlyoutForm from './template-parts/common/flyoutForm'
import ModalForm from './template-parts/common/modalform'
import Style5Form from './template-parts/common/style5form'
import MFormSelect from './template-parts/common/mf_select'
import TFSelectFormMob from './template-parts/common/top_footer_select_mobile'
import TFSelectForm from './template-parts/common/top_footer_select'
import SliderForm from './template-parts/common/sliderform'
import Style6Form from './template-parts/common/style6form'
import CoursesGrid from './template-parts/sections/courses-grid'
import TextsTabs from './template-parts/sections/texts-tabs'
import GeBl4Tabs from './template-parts/sections/grado_bl4-tabs'
import GeBl11Tabs from './template-parts/sections/grado_bl11-tabs'
import DFaqsTabs from './template-parts/sections/distrib_faqs-tabs'
import Modality from './template-parts/sections/modality'
import Header from './template-parts/common/header.js'
import Cookies from './template-parts/components/popups/cookies.js'

export default class ModulesLoader {
  constructor (el = document) {
    this.el = el
  }

  loadModules () {
    window.header = new Header()
    window.cookies = new Cookies()
    window.lazyLoading = new LazyLoading()
    window.hero = new Hero()
    window.footer = new Footer()
    window.contactForm = new ContactForm()
    window.contactForm2 = new ContactForm2()
    window.topfooter = new TopFooter()
    window.contactForm2 = new ContactForm2Mobile()
    window.contactForm4 = new CFBlogMobile()
    window.contactForm5 = new CFBlog()
    window.enrollmentBanner = new EnrollmentBanner()
    window.filters = new Filters()
    window.pagination = new Pagination()
    window.menu = new Menu()
    window.featuredAccordion = new FeaturedAccordion()
    window.grado_esp_bloque11 = new GeBl11MobileAccordion()
    window.distrib_faqs = new DistribFaqsMobileAccordion()
    window.distrib_faqs = new DFaqsTabs()
    window.home_bloque_10 = new HomeBl10Accordion()
    window.grado_especifico_bloque_4 = new TemarioAccordion()
    window.red_centros = new CentrosAccordion()
    window.featuredVideo = new FeaturedVideo()
    window.flyoutForm = new FlyoutForm()
    window.modalForm = new ModalForm()
    window.style5Form = new Style5Form()
    window.mfselect = new MFormSelect()
    window.tfsFormMB = new TFSelectFormMob()
    window.tfsForm = new TFSelectForm()
    window.sliderForm = new SliderForm()
    window.style6Form = new Style6Form()
    window.coursesGrid = new CoursesGrid()
    window.textsTabs = new TextsTabs()
    window.grado_esp_bloque4 = new GeBl4Tabs()
    window.grado_esp_bloque11 = new GeBl11Tabs()
    window.modality = new Modality()
    window.title = new Title()
    window.animationScenes = new AnimationScenes()
  }
}
